import { useState } from 'react';

export const useTemplateStatusModal = () => {
    const [statusModalIsOpen, setPublishModalIsOpen] = useState(false);
    const [templateIdToPublish, setTemplateToPublish] = useState(0);

    const openPublishModal = (templateId: number) => {
        setTemplateToPublish(templateId);
        setPublishModalIsOpen(true);
    };

    const closePublishModal = () => {
        setPublishModalIsOpen(false);
        setTemplateToPublish(0);
    };

    return {
        statusModalIsOpen,
        openPublishModal,
        templateIdToPublish,
        closePublishModal
    };
};
